import ModelBase from './ModelBase';
import Model from './Model';
import ModelDefinition from './ModelDefinition';
import ModelDefinitions from './ModelDefinitions';
import ModelValidation from './ModelValidation';

export default {
    ModelBase,
    Model,
    ModelDefinition,
    ModelDefinitions,
    ModelValidation,
};



/** WEBPACK FOOTER **
 ** ./src/model/models.js
 **/